import React, { useState, Fragment } from "react";
import {
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  Label,
  Form,
  FormGroup,
  Input,
  Spinner,
  Badge,
  CustomInput,
} from "reactstrap";

import style from "./MainCard.module.scss";

export const MainCard = ({ title, children }) => (
  <Card className={style.card}>
    <CardHeader className={style.cardHeader}>
      <Label className={style.label}>{title}</Label>
    </CardHeader>
    {children}
  </Card>
);
